import React, {useId} from "react";

import styles from "./CustomInputField.module.css"
import classnames from "classnames";

interface FieldProps {
    readOnly?: boolean
    disabled?: boolean
    isRequired: boolean
    title: string
    value?: any
    setValue: (value: any) => void
    placeholder?: string
    errorMessage?: string
    unit?: string
    maxLength?: number
    /** Values offered while typing; any other value can still be entered. */
    suggestions?: string[]
}


export const CustomInputField: React.FC<FieldProps> = ({
                                                           readOnly,
                                                           disabled,
                                                           isRequired,
                                                           title,
                                                           value,
                                                           setValue,
                                                           placeholder,
                                                           errorMessage,
                                                           unit,
                                                           maxLength,
                                                           suggestions
                                                       }) => {
    const suggestionsId = useId();
    const hasSuggestions = !!suggestions?.length && !disabled && !readOnly;
    return <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
            <span className={classnames(styles.title, disabled && styles.disabledTitle)}>{title}</span>
            {(isRequired && !disabled) && <span className={styles.asterisk}>*</span>}
        </div>
        <div className={styles.inputContainer}>
            <input
                value={disabled ? "" : value ?? ""}
                readOnly={readOnly}
                disabled={disabled}
                placeholder={placeholder}
                maxLength={maxLength}
                list={hasSuggestions ? suggestionsId : undefined}
                onChange={e => setValue(e.target.value)}
                className={classnames(
                    errorMessage ? styles.inputWithError : styles.input,
                    unit && styles.inputWithUnit
                )}
            />
            {unit && <span className={styles.unit}>{unit}</span>}
            {hasSuggestions && <datalist id={suggestionsId}>
                {suggestions!.map(suggestion => <option key={suggestion} value={suggestion}/>)}
            </datalist>}
        </div>
        <div style={{visibility: `${!errorMessage ? "hidden" : "visible"}`}} className={styles.errorWrapper}>
            <img src={"/alertIcon.svg"} alt={"alert icon"}/>
            <span className={styles.errorMessage}>{errorMessage}</span>
        </div>
    </div>
}
